import React from 'react'
import Button from '../Button'
import Icon, { IconType } from '../Icon'
import Col from '../Col'
import Row from '../Row'
import classNames from 'classnames'
import componentStyles from './DeleteAssetAlert.module.scss'
import styles from '@bt-react/styles'
import { DeleteAssetAlertProps } from './types'


const DeleteAssetAlert: React.FC<DeleteAssetAlertProps> = ({ channelId, webcastId, status, isCentral, setView, isNarrowView, attachments, activeResource, deleteResource }) => {
  return (
      <div className={classNames({
          [componentStyles['delete-asset-alert']]: true,
          [componentStyles['delete-asset-alert-narrow']]: isNarrowView
      })} data-bdd="delete-asset-alert">
          <div className={classNames(styles['font-weight-bold'], componentStyles['header-text'])}>
              {attachments ? 'Add a file or link to a file' : 'Add a file' }
          </div>
          <Row className={classNames(styles['m-0'], componentStyles['alert-container'])}>
              <Col xs={9} className={classNames(styles['p-0'], componentStyles['alert-msg'])}>
                  <Icon dataBdd="delete-asset-alert-icon" name={IconType.iconName.dangerCentral} colour={isCentral ? IconType.colour.darkOrange : IconType.colour.task} className={componentStyles['danger-icon']} />
                  You are about to delete this asset, are you sure you want to continue?
              </Col>
              <Col xs={isNarrowView ? 12 : 3} className={classNames(styles['p-0'], styles['text-right'])}>
                <Button
                    dataBdd="delete-asset-alert-no"
                    onClick={()=>setView('lists', true)}
                    text="No"
                    color={isCentral ? IconType.colour.darkOrange : IconType.colour.task}
                    className={classNames(componentStyles['no-btn'], {[componentStyles['no-btn-central']]: isCentral})}
                />
                <Button
                    dataBdd="delete-asset-alert-yes"
                    onClick={()=>{ attachments ? deleteResource(channelId, webcastId, activeResource.target ? activeResource.target.id : activeResource.id, 'delete') :
                        console.log('delete caption clicked') // TODO: Add the correct action here when ready
                    }}
                    loading={status.isDeleting}
                    text="Yes"
                    className={classNames(componentStyles['yes-btn'], {[componentStyles['yes-btn-central']]: isCentral})}
                />
              </Col>
          </Row>
      </div>
  )
}

export default DeleteAssetAlert